import { useMemo } from 'react'
import { createUserDashboardStore } from './stores/userDashboardStore'
import { UsersPage } from './UsersPage'

export const UsersPageContainer = () => {
	const store = useMemo(() => createUserDashboardStore(), [])

	return <UsersPage store={store} />
}
